// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import fetchGraphql from '@/graphql/fetchQuery';
import gql from '@/graphql/gql';
import { TournamentFragmentDoc } from './TournamentFragment.generated';
export type TournamentQueryVariables = Types.Exact<{
  tournamentId: Types.Scalars['String']['input'];
  site: Types.Scalars['String']['input'];
}>;


export type TournamentQuery = { __typename?: 'Query', casinoTournamentsPublic?: { __typename?: 'CasinoTournamentsPublic', id?: string, tournament?: { __typename?: 'CasinoTournamentsPublicTournament', id: string, enabled?: boolean, openAt?: any, closeAt?: any, iAmOptedIn?: boolean, name?: string, prizeText?: string, activityType?: string, shortUrl?: string, backgroundImageSmall?: string, backgroundImageLarge?: string, rules?: string, leaderboardType?: string, myScore?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> }, prizes?: Array<{ __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, automaticallyReleased?: boolean }>, leaderboard?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> } } };


export const TournamentQueryDocument = gql`
    query TournamentQuery($tournamentId: String!, $site: String!) {
  casinoTournamentsPublic {
    id
    tournament(tournamentId: $tournamentId, site: $site) {
      ...TournamentFragment
    }
  }
}
    ${TournamentFragmentDoc}`;

export const getTournamentQuery = async (variables: TournamentQueryVariables) => {
  return fetchGraphql<TournamentQuery, TournamentQueryVariables>(TournamentQueryDocument, "TournamentQuery", { variables });
}